<script setup lang="ts">

import {computed, HTMLAttributes} from 'vue'
import {FormControl, FormDescription, FormItem, FormLabel, FormMessage} from "@/shared/components/ui/form2/";
import {Input} from "@/shared/components/ui/input";
import {FormItemProps} from ".";
import {cn} from "@/shared/lib/utils.ts";
import {IconDefinition} from "@fortawesome/fontawesome-svg-core";
import FormError from "@/shared/components/ui/form2/FormError.vue";

interface FormInputProps extends FormItemProps {
  type?: "text" | "number" | "password",
  placeholder?: string,
  autocomplete?: boolean,
  icon?: IconDefinition
  clearable?: boolean
  class?: HTMLAttributes['class']
  elementClass?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<FormInputProps>(), {
  required: false,
  clearable: false,
  type: "text"
});
defineSlots<{
  label?: (props: {}) => any
  prepend?: (props: {}) => any
  append?: (props: {}) => any
}>()
const modelValue = defineModel<string | number>()
const hasError = computed(() => props.error != undefined)

const emits = defineEmits<{
  (e: 'update:clear'): void
}>()

const clearInput = () => {
  modelValue.value = ''
  emits('update:clear')
}
</script>

<template>
  <FormItem :class="cn('form-input w-full', props.class)">
    <FormLabel v-if="label" :error="hasError" class="flex items-center" :class="disabled? 'text-slate-400' : ''">{{ label }}{{ required ? '*' : '' }}<slot name="label"/></FormLabel>
    <FormControl>
      <Input :type="type"
             :disabled="disabled"
             :placeholder="placeholder"
             :class="[props.elementClass, { 'border-red-600': hasError }]"
             v-bind="{...$attrs}"
             v-model="modelValue"
             @update:clear="clearInput"
             :clearable="clearable"
             :autocomplete="autocomplete == false ? 'off' :''"
             :icon="icon">
        <template #prepend v-if="$slots.prepend">
          <slot name="prepend"/>
        </template>
        <template #append v-if="$slots.append">
          <slot name="append"/>
        </template>
      </Input>
      <FormError :error="error"/>
    </FormControl>
    <FormDescription v-if="description" v-html="description"/>
    <FormMessage/>
  </FormItem>
</template>

<style scoped>

</style>